import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

const truncate = (text, length) => {
  return (text && [text.slice(0, length), text.slice(length)]) || [];
}

class ShowMore extends React.Component {
  constructor(props) {
    super(props);

    this.state = { collapsed: false };
  }

  renderLink(tail) {
    const { collapsed } = this.state;
    return tail ? (
      <span>
        <Button
          className="tvt-show-more__link"
          bsStyle="link"
          onClick={() => this.setState({ collapsed: !collapsed })}
        >
          {!collapsed ? '(...)' : 'See less'}
        </Button>
      </span>
    ) : null;
  }

  render() {
    const { text, maxLength } = this.props;
    const [head, tail] = truncate(text, maxLength);

    return (
      <p className="tvt-show-more">
        <span>{head}</span>
        {this.state.collapsed && <span>{tail}</span>}
        {this.renderLink(tail)}
      </p>
    );
  }
}

ShowMore.propTypes = {
  text: PropTypes.string.isRequired,
  maxLength: PropTypes.number
};

ShowMore.defaultProps = {
  maxLength: 140
};

export default ShowMore;
